import React from 'react'
import s from './GeoentityBlock.less'
import DefaultBlock from './DefaultBlock'
import { withEmptyFallbackErrorBoundary } from '../../error/EmptyFallbackErrorBoundary'
import classNames from 'classnames'
import GeoentityBlockTitle from './GeoentityBlockTitle'
import GeoentityBlockMenu from './GeoentityBlockMenu'
import GeoentityBlockLink from './GeoentityBlockLink'
import GeoentityBlockKeyValue from './GeoentityBlockKeyValue'
import GeoentityBlockRating from './GeoentityBlockRating'
import GeoentityBlockOffers from './GeoentityBlockOffers'
import GeoentityBlockTable from './GeoentityBlockTable'
import GeoentityBlock360 from './GeoentityBlock360'
import GeoentityBlockText from './GeoentityBlockText'
import GeoentityBlockContentWidget from './GeoentityBlockContentWidget'
import GeoentityBlockTextList from './GeoentityBlockTextList'
import GeoentityBlockServiceList from './GeoentityBlockServiceList'
import GeoentityBlockImage from './GeoentityBlockImage'
import GeoentityBlockPublicTransport from './GeoentityBlockPublicTransport'
import GeoentityBlockImageList from './GeoentityBlockImageList'
import GeoentityBlockLinkList from './GeoentityBlockLinkList'
import GeoentityBlockSource from './GeoentityBlockSource'

export const getBlockComponent = type => {
  switch (type) {
    case 'title':
      return GeoentityBlockTitle
    case 'price_list':
      return GeoentityBlockMenu
    case 'key_value':
      return GeoentityBlockKeyValue
    case 'link':
      return GeoentityBlockLink
    case 'link_list':
      return GeoentityBlockLinkList
    case 'rating':
      return GeoentityBlockRating
    case 'offers':
      return GeoentityBlockOffers
    case 'table':
      return GeoentityBlockTable
    case 'panoramic':
      return GeoentityBlock360
    case 'text':
      return GeoentityBlockText
    case 'content_widget':
      return GeoentityBlockContentWidget
    case 'text_list':
      return GeoentityBlockTextList
    case 'service_list':
      return GeoentityBlockServiceList
    case 'image':
      return GeoentityBlockImage
    case 'image_list':
      return GeoentityBlockImageList
    case 'tc':
      return GeoentityBlockPublicTransport
    case 'source':
      return GeoentityBlockSource
    default:
      return DefaultBlock
  }
}

export function GeoentityBlock(props) {
  const { block = {}, lightMargin } = props
  const { type } = block

  const Block = getBlockComponent(type)
  return (
    <div className={classNames(s.BlockContainer, lightMargin && s.lightMargin)}>
      <Block data={block} />
    </div>
  )
}
export default withEmptyFallbackErrorBoundary(GeoentityBlock)
